import * as tslib_1 from "tslib";
import { Attr, Value, Text, Form, StringInput, Iteratee, StringOutput, Recon } from '@swim/recon';
function widthUnit(node) {
    while (node) {
        if (node instanceof HTMLElement && node.offsetParent instanceof HTMLElement) {
            return node.offsetParent.offsetWidth;
        }
        node = node.parentNode || undefined;
    }
    return 0;
}
function emUnit(node) {
    while (node) {
        if (node instanceof Element) {
            var fontSize = getComputedStyle(node).fontSize;
            if (fontSize !== null) {
                return parseFloat(fontSize);
            }
        }
        node = node.parentNode || undefined;
    }
    return 0;
}
function remUnit() {
    var fontSize = getComputedStyle(document.documentElement).fontSize;
    if (fontSize !== null) {
        return parseFloat(fontSize);
    }
    return 0;
}
var Length = (function () {
    function Length() {
    }
    Length.prototype.isDefined = function () {
        return this.value !== 0;
    };
    Object.defineProperty(Length.prototype, "unitValue", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Length.prototype.emValue = function () {
        return this.pxValue() / emUnit(this.node);
    };
    Length.prototype.remValue = function () {
        return this.pxValue() / remUnit();
    };
    Length.prototype.pctValue = function () {
        return this.px().value / this.unitValue;
    };
    Length.prototype.px = function () {
        return new PxLength(this.pxValue(), this.node);
    };
    Length.prototype.em = function () {
        return new EmLength(this.emValue(), this.node);
    };
    Length.prototype.rem = function () {
        return new RemLength(this.remValue(), this.node);
    };
    Length.prototype.pct = function () {
        return new PctLength(this.pctValue(), this.node);
    };
    Length.prototype.toValue = function (units) {
        switch (units) {
            case 'px': return this.pxValue();
            case 'em': return this.emValue();
            case 'rem': return this.remValue();
            case '%': return this.pctValue();
            default: throw new TypeError(units);
        }
    };
    Length.prototype.to = function (units) {
        switch (units) {
            case 'px': return this.px();
            case 'em': return this.em();
            case 'rem': return this.rem();
            case '%': return this.pct();
            default: throw new TypeError(units);
        }
    };
    Length.prototype.equals = function (that) {
        if (that instanceof Length) {
            return this.value === that.value && this.units === that.units && this.node === that.node;
        }
        return false;
    };
    Length.prototype.toString = function () {
        return this.value + this.units;
    };
    Length.form = function (node) {
        if (node) {
            return new LengthForm(node);
        }
        else {
            return Length.Form;
        }
    };
    Length.zero = function (node) {
        return new PxLength(0, node);
    };
    Length.px = function (value, node) {
        return new PxLength(value, node);
    };
    Length.em = function (value, node) {
        return new EmLength(value, node);
    };
    Length.rem = function (value, node) {
        return new RemLength(value, node);
    };
    Length.pct = function (value, node) {
        return new PctLength(value, node);
    };
    Length.unitless = function (value, node) {
        return new UnitlessLength(value, node);
    };
    Length.fromAny = function (value, units, node) {
        if (value instanceof Length) {
            return value;
        }
        else if (typeof value === 'number') {
            if (typeof units === 'string') {
                switch (units) {
                    case 'px': return new PxLength(value, node);
                    case 'em': return new EmLength(value, node);
                    case 'rem': return new RemLength(value, node);
                    case '%': return new PctLength(value, node);
                    case '': return new UnitlessLength(value, node);
                    default: throw new Error(units);
                }
            }
            else {
                if (units !== undefined) {
                    node = units;
                }
                return new PxLength(value, node);
            }
        }
        else if (typeof value === 'string' && typeof units !== 'string') {
            return Length.parse(value, units);
        }
        else {
            throw new Error();
        }
    };
    Length.fromValue = function (value, node) {
        if (value.length === 2) {
            var num = value.getItem(0).numberValue();
            var units = value.getItem(1);
            if (num !== undefined && isFinite(num) && units instanceof Attr && units.value === Value.Extant) {
                switch (units.key.value) {
                    case 'px': return new PxLength(num, node);
                    case 'em': return new EmLength(num, node);
                    case 'rem': return new RemLength(num, node);
                    case 'pct': return new PctLength(num, node);
                    default:
                }
            }
        }
        return undefined;
    };
    Length.parse = function (str, node) {
        var input = new StringInput(str);
        while (!input.isEmpty() && Iteratee.isSpace(input.head())) {
            input.step();
        }
        var output = LengthParser.parse(input, node);
        if (output.isDone()) {
            while (!input.isEmpty() && Iteratee.isSpace(input.head())) {
                input.step();
            }
            if (!input.isEmpty()) {
                output = Iteratee.unexpected(input);
            }
        }
        return output.bind();
    };
    Length.widthUnit = function () {
        return widthUnit(this.node);
    };
    Length.emUnit = function () {
        return emUnit(this.node);
    };
    Length.Form = undefined;
    return Length;
}());
export { Length };
var PxLength = (function (_super) {
    tslib_1.__extends(PxLength, _super);
    function PxLength(value, node) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.node = node;
        return _this;
    }
    Object.defineProperty(PxLength.prototype, "units", {
        get: function () {
            return 'px';
        },
        enumerable: true,
        configurable: true
    });
    PxLength.prototype.pxValue = function () {
        return this.value;
    };
    PxLength.prototype.px = function () {
        return this;
    };
    return PxLength;
}(Length));
export { PxLength };
var EmLength = (function (_super) {
    tslib_1.__extends(EmLength, _super);
    function EmLength(value, node) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.node = node;
        return _this;
    }
    Object.defineProperty(EmLength.prototype, "units", {
        get: function () {
            return 'em';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmLength.prototype, "unitValue", {
        get: function () {
            return emUnit(this.node);
        },
        enumerable: true,
        configurable: true
    });
    EmLength.prototype.pxValue = function () {
        return this.unitValue * this.value;
    };
    EmLength.prototype.em = function () {
        return this;
    };
    return EmLength;
}(Length));
export { EmLength };
var RemLength = (function (_super) {
    tslib_1.__extends(RemLength, _super);
    function RemLength(value, node) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.node = node;
        return _this;
    }
    Object.defineProperty(RemLength.prototype, "units", {
        get: function () {
            return 'rem';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RemLength.prototype, "unitValue", {
        get: function () {
            return remUnit();
        },
        enumerable: true,
        configurable: true
    });
    RemLength.prototype.pxValue = function () {
        return this.unitValue * this.value;
    };
    RemLength.prototype.rem = function () {
        return this;
    };
    return RemLength;
}(Length));
export { RemLength };
var PctLength = (function (_super) {
    tslib_1.__extends(PctLength, _super);
    function PctLength(value, node) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.node = node;
        return _this;
    }
    Object.defineProperty(PctLength.prototype, "units", {
        get: function () {
            return '%';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PctLength.prototype, "unitValue", {
        get: function () {
            return widthUnit(this.node);
        },
        enumerable: true,
        configurable: true
    });
    PctLength.prototype.pxValue = function (unitValue) {
        if (unitValue === void 0) { unitValue = this.unitValue; }
        return unitValue * this.value / 100;
    };
    PctLength.prototype.pct = function () {
        return this;
    };
    return PctLength;
}(Length));
export { PctLength };
var UnitlessLength = (function (_super) {
    tslib_1.__extends(UnitlessLength, _super);
    function UnitlessLength(value, node) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.node = node;
        return _this;
    }
    Object.defineProperty(UnitlessLength.prototype, "units", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    UnitlessLength.prototype.pxValue = function () {
        return this.value;
    };
    return UnitlessLength;
}(Length));
export { UnitlessLength };
var LengthParser = (function (_super) {
    tslib_1.__extends(LengthParser, _super);
    function LengthParser(node, valueParser, unitsOutput, step) {
        var _this = _super.call(this) || this;
        _this.node = node;
        _this.valueParser = valueParser;
        _this.unitsOutput = unitsOutput;
        _this.step = step;
        return _this;
    }
    LengthParser.prototype.feed = function (input) {
        return LengthParser.parse(input, this.node, this.valueParser, this.unitsOutput, this.step);
    };
    LengthParser.parse = function (input, node, valueParser, unitsOutput, step) {
        if (step === void 0) { step = 1; }
        var c = 0;
        if (step === 1) {
            if (!valueParser) {
                valueParser = Recon.Factory.parseDecimal(input);
            }
            while ((!input.isEmpty() || input.isDone()) && valueParser.isCont()) {
                valueParser = valueParser.feed(input);
            }
            if (valueParser.isDone()) {
                step = 2;
            }
            else if (valueParser.isError()) {
                return valueParser.asError();
            }
        }
        if (step === 2) {
            unitsOutput = unitsOutput || new StringOutput();
            while (!input.isEmpty() && (c = input.head(), Iteratee.isAlpha(c) || c === 37)) {
                input.step();
                unitsOutput.push(c);
            }
            if (!input.isEmpty() || input.isDone()) {
                var value = valueParser.bind().numberValue();
                var units = unitsOutput.bind();
                switch (units) {
                    case 'px': return Iteratee.done(new PxLength(value, node));
                    case 'em': return Iteratee.done(new EmLength(value, node));
                    case 'rem': return Iteratee.done(new RemLength(value, node));
                    case '%': return Iteratee.done(new PctLength(value, node));
                    case '': return Iteratee.done(new UnitlessLength(value, node));
                    default: return Iteratee.error(units);
                }
            }
        }
        return new LengthParser(node, valueParser, unitsOutput, step);
    };
    return LengthParser;
}(Iteratee));
export { LengthParser };
var LengthForm = (function (_super) {
    tslib_1.__extends(LengthForm, _super);
    function LengthForm(node) {
        var _this = _super.call(this) || this;
        _this.node = node;
        return _this;
    }
    Object.defineProperty(LengthForm.prototype, "unit", {
        get: function () {
            return Length.zero(this.node);
        },
        enumerable: true,
        configurable: true
    });
    LengthForm.prototype.mold = function (length) {
        length = Length.fromAny(length);
        return Text.valueOf(length.toString());
    };
    LengthForm.prototype.cast = function (value) {
        var length;
        try {
            length = Length.fromValue(value);
            if (!length) {
                var str = value.stringValue();
                if (str !== undefined) {
                    length = Length.parse(str);
                }
            }
        }
        catch (e) {
        }
        return length;
    };
    return LengthForm;
}(Form));
Length.Form = new LengthForm();
//# sourceMappingURL=data:application/json;base64,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